import axios from 'axios';

export const downloadFile = ({ url, fileName, isSaveAs, onFetched }) => {
  if (isSaveAs) {
    axios
      .get(url, {
        headers: {
          'Content-Type': 'application/octet-stream',
        },
        responseType: 'blob',
      })
      .then((response) => {
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(response.data);
        a.href = url;
        a.download = fileName;
        if (typeof onFetched === 'function') {
          onFetched();
        }
        a.click();
      })
      .catch((err) => {
        console.log('Download file error', err);
      });
  } else {
    const buttonElement = document.createElement('a');
    buttonElement.href = url;
    if (typeof onFetched === 'function') {
      onFetched();
    }
    buttonElement.click();
  }
};
